import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-multi-slider',
  templateUrl: './multi-slider.component.html',
  styleUrls: ['./multi-slider.component.scss']
})
export class MultiSliderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
